import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { Subject } from 'rxjs';
import { LinkableLocationsService, ProfileLocation } from 'src/app/api/linkable-locations.service';

@Component({
    selector: 'app-location-dropdown',
    templateUrl: './location-dropdown.component.html',
    styleUrls: ['./location-dropdown.component.scss'],
    imports: [AutoCompleteModule, FormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LocationDropdownComponent),
            multi: true
        }
    ],
})
export class LocationDropdownComponent implements OnInit, ControlValueAccessor {

  constructor(
    private locationService: LinkableLocationsService
  ) { }

  onChange: any = () => { };
  onTouched: any = () => { };
  disabled = false;

  selectedLocation: ProfileLocation | undefined;
  dropdownItems: ProfileLocation[] = []

  private _locations: ProfileLocation[] = [];
  @Input() set locations(value: ProfileLocation[]) {

    this._locations = [...value].sort((a, b) => a.name.localeCompare(b.name))
    this.updateAllowEmpty()
    this.dropdownItems = this._locations
    
  }

  get locations(): ProfileLocation[] {
    return this._locations;
  }

  private _allowEmpty: boolean = false
  @Input() set allowEmpty(value: boolean) {
    this._allowEmpty = value
    this.updateAllowEmpty()

  }

  get allowEmpty(): boolean {
    return this._allowEmpty
  }

  readonly emptyLocation: ProfileLocation = {
    name: "None",
    id: "",
    region: "",
    active: 1,
    public: 1,
    domestic: 1,
    domesticRegion: "",
    readinessLocation: 0,
    airport1: "",
    airport2: "",
    airport3: ""
  }


  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


  writeValue(value: string): void {

    if (value) {
      this.selectedLocation = this.dropdownItems.find(l => l.id === value)
    }


  }

  search(event: any) {
    if (!event.query) {
      this.dropdownItems = [...this.locations]
    } else {
      this.dropdownItems = this.locations.filter(l => l.name.toLowerCase().includes(event.query.toLowerCase()))
    }
  }

  onLocationSelected(event: AutoCompleteSelectEvent) {
    this.onChange(event.value.id)
  }

  onLocationCleared() {
    this.selectedLocation = undefined
    this.onChange(null)
  }

  updateAllowEmpty() {
    if (this.allowEmpty) {
      if (!this._locations.find(l => l.id === "")) {
        this._locations = [this.emptyLocation, ...this._locations]
      }
    }
    else {
      this._locations = this._locations.filter(l => l.id !== "")
    }
  }

}
